<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import * as XLSX from "xlsx";

/**
 * User List Management Page
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "User List",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],
      adminlist: [],
      adminsearch: "",
      userinfo: null,
      loading: true,
      block: false,
      systemtype: 0,
      pagesize: 10,
      currentPage: 1,
      totalrows: 0,
      allpage: 0,
      chargeUserOptions: [],
      chargeUserLoading: false,
      searchTimer: null,
      cashierconfig: [],
      cashierstatus: 0,
      withdrawalstatus: false,
      chargetype: false,
      chargedata: {
        uid: "",
        amount: "",
      },
      showamountchange: false,
      deleteLoading: {},
      updateLoading: {},
      withdrawalLoading: {},
      cloudSyncLoading: {},
      cloudSyncReady: false,
    };
  },
  mounted() {
    this.title = this.$t("menuitems.user.text");
    this.items = [
      {
        text: this.$t("menuitems.user.text"),
        active: true,
      },
    ];

    try {
      this.userinfo = JSON.parse(localStorage.getItem("user"));
      if (!this.userinfo) {
        this.$message.error(this.$t("global.errors.loginrequired"));
        this.$router.push({ name: "login" });
        return;
      }
      {
        const rid = parseInt(
          this.userinfo.roleid != null
            ? this.userinfo.roleid
            : this.userinfo.roleId,
          10
        );
        if (Number.isFinite(rid) ? rid !== 0 : parseInt(this.userinfo.topuid, 10) >= 1) {
          this.block = true;
        }
      }
    } catch (error) {
      console.error("解析用户信息失败:", error);
      this.$message.error(this.$t("global.errors.loginrequired"));
      this.$router.push({ name: "login" });
      return;
    }

    this.getsysteminfo();
    this.getCloudSyncPortalStatus();
    this.getadminlist();
    this.getcashierconfig();
    this.getwithdrawalstatus();
    this.getchargetype();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    getCloudSyncPortalStatus() {
      this.$axios
        .post(
          this.apiuri,
          { action: "syncbindportalstatus" },
          { headers: { Openid: this.userinfo.openid } }
        )
        .then((response) => {
          if (response.data.status === 200 && response.data.data) {
            this.cloudSyncReady = !!response.data.data.sync_ready;
          }
        })
        .catch(() => {});
    },
    getsysteminfo() {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.systemtype = parseInt(response.data.data.model);
        })
        .catch((error) => {
          console.error("获取系统信息失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    getadminlist() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "userlist",
            page: this.currentPage,
            limit: this.pagesize,
            keyword: this.adminsearch.trim(),
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200) {
            this.adminlist = response.data.data || [];
            this.cloudSyncReady = this.adminlist.length > 0
              ? !!this.adminlist[0].cloud_sync_ready
              : false;
            this.totalrows = parseInt(response.data.total) || 0;
            this.allpage = parseInt(response.data.allpage) || 0;
          } else {
            this.$message.error(response.data.message || this.$t("global.errors.loaddata"));
            this.adminlist = [];
            this.totalrows = 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取用户列表失败:", error);
          this.$message.error(this.$t("global.errors.network"));
          this.adminlist = [];
          this.totalrows = 0;
        });
    },
    deleteadmin(id) {
      this.$confirm(
        this.$t("global.delete.deleteusertip"),
        this.$t("global.delete.sureyouaction"),
        {
          confirmButtonText: this.$t("global.button.ok"),
          cancelButtonText: this.$t("global.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$set(this.deleteLoading, id, true);
          this.$axios
            .post(
              this.apiuri,
              {
                action: "delete",
                type: "user",
                id: id,
              },
              {
                headers: { Openid: this.userinfo.openid },
              }
            )
            .then((response) => {
              this.$set(this.deleteLoading, id, false);
              if (response.data.status === 200) {
                this.$message({
                  message: this.$t("global.delete.success"),
                  type: "success",
                });
                this.getadminlist();
              } else if (response.data.status === 403) {
                this.$message({
                  message: this.$t("global.delete.auth"),
                  type: "warning",
                });
              } else if (response.data.status === 404) {
                this.$message({
                  message: this.$t("device.orders.noorder"),
                  type: "warning",
                });
              } else {
                this.$message.error(response.data.message || this.$t("global.delete.500"));
              }
            })
            .catch((error) => {
              this.$set(this.deleteLoading, id, false);
              console.error("删除用户失败:", error);
              this.$message.error(this.$t("global.errors.network"));
            });
        })
        .catch(() => {});
    },

    onSearchInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getadminlist();
      }, 400);
    },
    loadChargeUserOptions(keyword) {
      this.chargeUserLoading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "userlist",
            page: 1,
            limit: 50,
            keyword: (keyword || "").trim(),
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.chargeUserLoading = false;
          if (response.data.status === 200) {
            this.chargeUserOptions = response.data.data || [];
          } else {
            this.chargeUserOptions = [];
          }
        })
        .catch(() => {
          this.chargeUserLoading = false;
          this.chargeUserOptions = [];
        });
    },
    handleSizeChange(psize) {
      this.pagesize = psize;
      this.currentPage = 1;
      this.getadminlist();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getadminlist();
    },
    refresh() {
      this.getadminlist();
    },
    exportToExcel() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "userlist",
            page: 1,
            limit: 10,
            keyword: this.adminsearch.trim(),
            export: 1,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status !== 200) {
            this.$message.error(response.data.message || this.$t("global.errors.loaddata"));
            return;
          }
          let newdata = (response.data.data || []).map((item) => ({ ...item }));
          for (let i = 0; i < newdata.length; i++) {
            if (newdata[i].status == 1) {
              newdata[i].status = this.$t("admin.lists.normal");
            } else if (newdata[i].status == 0) {
              newdata[i].status = this.$t("admin.lists.disable");
            }
          }
          const worksheet = XLSX.utils.json_to_sheet(newdata);
          XLSX.utils.sheet_add_aoa(worksheet, [
            [
              this.$t("admin.lists.userid"),
              this.$t("admin.lists.username"),
              this.$t("admin.lists.phone"),
              this.$t("user.list.membercard"),
              this.$t("user.list.membercardhex"),
              this.$t("user.list.amount"),
              this.$t('admin.lists.status')
            ]
          ],
            {
              origin: "A1"
            });
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          const date = new Date();
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          XLSX.writeFile(workbook, this.$t("user.list.name") + `${year}-${month}-${day}` + "tableData.xlsx");
        })
        .catch((error) => {
          this.loading = false;
          console.error("导出用户列表失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    updateuserinfo(id) {
      this.$set(this.updateLoading, id, true);
      this.$axios
        .post(
          this.apiuri,
          {
            action: "updateuserinfo",
            id: id,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.$set(this.updateLoading, id, false);
          if (response.data.status === 200) {
            this.$message({
              message: this.$t("global.alert.updateuser"),
              type: "success",
            });
            this.getadminlist();
          } else if (response.data.status === 403) {
            this.$message({
              message: this.$t("global.delete.auth"),
              type: "warning",
            });
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.delete.500"));
          }
        })
        .catch((error) => {
          this.$set(this.updateLoading, id, false);
          console.error("更新用户信息失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    getcashierconfig() {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "get_cashier_config",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          if (response.data.status === 200) {
            this.cashierconfig = response.data.config || {};
            this.cashierstatus = this.cashierconfig.status || 0;
          }
        })
        .catch((error) => {
          console.error("获取收银配置失败:", error);
        });
    },
    withdrawal(uid) {
      this.$set(this.withdrawalLoading, uid, true);
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getwithdrawalvalue",
            uid: uid,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.$set(this.withdrawalLoading, uid, false);
          if (response.data.amount === 0 || !response.data.amount) {
            this.$message.error(this.$t("user.detail.amountlog.withdrawalfail"));
          } else {
            const promptMessage = this.$t("user.detail.amountlog.withdrawaltip") 
              ? `${this.$t("user.detail.amountlog.withdrawaltip")}，${this.$t("global.text.total")}：${response.data.amount}`
              : `请输入提现金额，当前可提现${response.data.amount}`;
            this.$prompt(
              promptMessage,
              this.$t("global.waring"),
              {
                confirmButtonText: this.$t("global.button.ok"),
                cancelButtonText: this.$t("global.button.cancel"),
                inputPattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
                inputErrorMessage: this.$t("user.detail.amountlog.amountformaterror") || "请输入正确的格式，可保留两位小数"
              }
            )
              .then(({ value }) => {
                this.loading = true;
                this.$axios
                  .post(
                    this.apiuri,
                    {
                      action: "dowithdrawal",
                      uid: uid,
                      amount: value,
                    },
                    {
                      headers: { Openid: this.userinfo.openid },
                    }
                  )
                  .then((response) => {
                    this.loading = false;
                    if (response.data.status === 200) {
                      this.$message({
                        message: this.$t("user.detail.amountlog.withdrawalsuccess"),
                        type: "success",
                      });
                      this.getadminlist();
                    } else {
                      this.$message.error(response.data.message || this.$t("user.detail.amountlog.withdrawalfail"));
                    }
                  })
                  .catch((error) => {
                    this.loading = false;
                    console.error("提现操作失败:", error);
                    this.$message.error(this.$t("global.errors.network"));
                  });
              })
              .catch(() => {});
          }
        })
        .catch((error) => {
          this.$set(this.withdrawalLoading, uid, false);
          console.error("获取提现金额失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    getwithdrawalstatus() {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "withdrawalstatus",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.withdrawalstatus = response.data.status === 200;
        })
        .catch((error) => {
          console.error("获取提现状态失败:", error);
          this.withdrawalstatus = false;
        });
    },
    getchargetype() {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "chargetype",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.chargetype = response.data.status === 200;
        })
        .catch((error) => {
          console.error("获取充值类型失败:", error);
          this.chargetype = false;
        });
    },
    cloudSyncStatusLabel(row) {
      if (!this.cloudSyncReady) {
        return this.$t("user.cloudsync.platform_not_bound");
      }
      var status = row.cloud_sync && row.cloud_sync.sync_status
        ? row.cloud_sync.sync_status
        : "unlinked";
      var key = "user.cloudsync.status_" + status;
      if (this.$te(key)) {
        return this.$t(key);
      }
      return status;
    },
    cloudSyncStatusType(row) {
      if (!this.cloudSyncReady) {
        return "info";
      }
      var status = row.cloud_sync && row.cloud_sync.sync_status
        ? row.cloud_sync.sync_status
        : "unlinked";
      if (status === "linked" || status === "submitted") {
        return "success";
      }
      if (status === "failed") {
        return "danger";
      }
      return "info";
    },
    syncUserToCloud(userId) {
      var that = this;
      if (!that.cloudSyncReady) {
        that.$message.warning(that.$t("user.cloudsync.platform_not_bound"));
        return;
      }
      that.$set(that.cloudSyncLoading, userId, true);
      that.$axios
        .post(
          that.apiuri,
          {
            action: "syncusercloudprofile",
            uid: userId,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$set(that.cloudSyncLoading, userId, false);
          if (response.data.status === 200) {
            that.$message.success(that.$t("user.cloudsync.sync_success"));
            that.getadminlist();
          } else {
            var msg = response.data.msg || that.$t("user.cloudsync.sync_fail");
            that.$message.error(msg);
            that.getadminlist();
          }
        })
        .catch(function () {
          that.$set(that.cloudSyncLoading, userId, false);
          that.$message.error(that.$t("global.errors.network"));
        });
    },
    makechargeamount() {
      if (!this.chargedata.uid) {
        this.$message.error(this.$t("user.detail.amountlog.selectuser"));
        return false;
      }
      if (!this.chargedata.amount || parseFloat(this.chargedata.amount) <= 0) {
        this.$message.error(this.$t("user.detail.amountlog.inputamount"));
        return false;
      }
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "makechargeamount",
            uid: this.chargedata.uid,
            amount: this.chargedata.amount,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200) {
            this.$message({
              message: this.$t("user.detail.amountlog.chargesuccess"),
              type: "success",
            });
            this.showamountchange = false;
            this.chargedata = { uid: "", amount: "" };
            this.getadminlist();
          } else {
            this.$message.error(response.data.message || this.$t("user.detail.amountlog.chargefail"));
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("充值操作失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    }
  },
  watch: {
    showamountchange(val) {
      if (val) {
        this.loadChargeUserOptions("");
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading">
            <!-- 操作按钮栏 -->
            <div class="row mb-3">
              <div class="col-md-12">
                <router-link :to="{ path: '/user/add' }">
                  <el-button type="success" round icon="el-icon-plus">{{
                    $t("admin.add.text")
                  }}</el-button>
                </router-link>
                <router-link :to="{ path: '/user/group' }" v-if="systemtype == 2">
                  <el-button type="primary" round icon="el-icon-user-solid">{{
                    $t("admin.group.text")
                  }}</el-button>
                </router-link>
                <router-link :to="{ path: '/user/temporary' }" v-if="systemtype == 2">
                  <el-button type="info" round icon="el-icon-time">{{
                    $t("admin.temporary.text")
                  }}</el-button>
                </router-link>
                <el-button 
                  type="primary" 
                  @click="exportToExcel" 
                  round
                  icon="el-icon-download"
                  :disabled="totalrows === 0"
                >{{
                  $t("user.detail.amountlog.exportexcel")
                }}</el-button>
                <el-button 
                  type="success" 
                  round 
                  v-if="chargetype" 
                  @click="showamountchange = true"
                  icon="el-icon-wallet"
                >{{
                  $t("user.list.amountcharge")
                }}</el-button>
              </div>
            </div>

            <!-- 搜索栏 -->
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="input-group">
                  <input 
                    type="search" 
                    v-model="adminsearch" 
                    class="form-control" 
                    :placeholder="$t('user.list.search')"
                    @input="onSearchInput"
                    @keyup.enter="currentPage = 1; getadminlist()"
                  />
                  <div class="input-group-append">
                    <el-button 
                      icon="el-icon-refresh" 
                      @click="refresh"
                      :loading="loading"
                      circle
                    ></el-button>
                  </div>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <span class="text-muted">
                  {{ $t('global.text.total') }}: <strong>{{ totalrows }}</strong>
                </span>
              </div>
            </div>

            <!-- 数据表格 -->
            <div class="row">
              <div class="col-12">
                <el-table 
                  :data="adminlist" 
                  style="width: 100%"
                  stripe
                  border
                  :empty-text="$t('global.text.nodata')"
                >
                  <el-table-column 
                    prop="username" 
                    :label="$t('admin.lists.username')"
                    min-width="120"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column 
                    prop="phone" 
                    :label="$t('admin.lists.phone')"
                    min-width="150"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.phone">{{ scope.row.phone }}</span>
                      <span v-else class="text-muted">{{ $t("admin.lists.nophone") }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="source"
                    :label="$t('user.list.source')"
                    min-width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.source !== undefined && scope.row.source !== null && scope.row.source !== ''">
                        {{ scope.row.source }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="bindshop"
                    :label="$t('user.list.bindshop')"
                    min-width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.bindshop">{{ scope.row.bindshop }}</span>
                      <span v-else class="text-muted">-</span>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    prop="cardno" 
                    :label="$t('user.list.membercard')"
                    min-width="150"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column 
                    :label="$t('user.list.membercardhex')"
                    min-width="180"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.hex">{{ scope.row.hex }}</span>
                      <span v-else class="text-muted">{{ $t("user.detail.cardnobind") }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    prop="amount" 
                    :label="$t('user.list.amount')"
                    min-width="120"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.amount !== undefined && scope.row.amount !== null">
                        ¥{{ parseFloat(scope.row.amount || 0).toFixed(2) }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    :label="$t('admin.lists.status')"
                    min-width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag 
                        :type="scope.row.status == 1 ? 'success' : 'danger'" 
                        size="mini"
                      >
                        {{ scope.row.status == 1 ? $t("admin.lists.normal") : $t("admin.lists.disable") }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('user.cloudsync.status')"
                    min-width="120"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag :type="cloudSyncStatusType(scope.row)" size="mini">
                        {{ cloudSyncStatusLabel(scope.row) }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    :label="$t('device.lists.action')"
                    width="520"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <router-link :to="{ path: '/user/detail', query: { id: scope.row.id } }">
                        <el-button size="mini" type="primary" icon="el-icon-view">{{
                          $t("user.list.info")
                        }}</el-button>
                      </router-link>
                      <router-link :to="{ path: '/user/edit', query: { id: scope.row.id } }">
                        <el-button size="mini" type="primary" icon="el-icon-edit">{{
                          $t("admin.lists.edit")
                        }}</el-button>
                      </router-link>
                      <el-button
                        size="mini"
                        type="success"
                        @click="syncUserToCloud(scope.row.id)"
                        v-if="cloudSyncReady"
                        :loading="cloudSyncLoading[scope.row.id]"
                        icon="el-icon-upload2"
                      >{{
                        $t("user.cloudsync.syncbtn")
                      }}</el-button>
                      <el-button 
                        size="mini" 
                        type="success" 
                        @click="updateuserinfo(scope.row.id)"
                        v-if="cashierstatus && cashierconfig.type == 'youhao'"
                        :loading="updateLoading[scope.row.id]"
                        icon="el-icon-refresh"
                      >{{
                        $t("admin.lists.update")
                      }}</el-button>
                      <el-button 
                        size="mini" 
                        type="warning" 
                        @click="withdrawal(scope.row.id)" 
                        v-if="withdrawalstatus"
                        :loading="withdrawalLoading[scope.row.id]"
                        icon="el-icon-money"
                      >{{
                        $t("admin.lists.withdrawal")
                      }}</el-button>
                      <el-button 
                        size="mini" 
                        type="danger" 
                        @click="deleteadmin(scope.row.id)" 
                        v-if="$hasPermission('admin.delete')"
                        :loading="deleteLoading[scope.row.id]"
                        icon="el-icon-delete"
                      >{{ $t("device.lists.delete") }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <!-- 分页 -->
            <div class="row mt-3" v-if="totalrows > 0">
              <div class="col-12">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalrows"
                  class="text-right"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Dialog -->
    <el-dialog :title="$t('user.detail.changeamount')" :visible.sync="showamountchange" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="chargedata">
        <el-form-item :label="$t('admin.lists.username')">
          <el-select
            v-model="chargedata.uid"
            filterable
            remote
            reserve-keyword
            :remote-method="loadChargeUserOptions"
            :loading="chargeUserLoading"
            :placeholder="$t('global.text.select')"
          >
            <el-option v-for="item in chargeUserOptions" :key="item.id" :label="item.username" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('user.detail.price')">
          <el-input v-model="chargedata.amount" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showamountchange = false">{{
          $t("global.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="makechargeamount()">{{
          $t("global.button.ok")
        }}</el-button>
      </div>
    </el-dialog>
  </Layout>
</template>
<style scoped>
.resource-page {
  margin-top: 20px;
  text-align: center;
}
</style>